// client/src/components/marketer/project/constants.js
export const API_URL = process.env.REACT_APP_API_URL || '';

export const TYPES = [
  { 
    key: 'delivery',  
    label: '제품 제공 방식',
    description: '인플루언서에게 홍보할 제품을 제공(배송)하고 인플루언서가 제품을 콘텐츠를 통해 광고하는 형식입니다.',
    icon: '📦'
  },
  { 
    key: 'purchase',  
    label: '제품 미제공 방식',
    description: '인플루언서가 광고주가 제공하는 이미지 혹은 동영상 자료를 통해 광고하거나, 제품을 직접 구매하여 광고하는 형식입니다.',
    icon: '🛒'
  },
  { 
    key: 'visit',     
    label: '장소(서비스) 광고 방식',
    description: '인플루언서가 홍보할 장소(서비스)에 직접 방문하여 콘텐츠를 통해 광고하는 형식입니다.',
    icon: '📍'
  },
  { 
    key: 'free',      
    label: '자율 형식',
    description: '원하는 진행 방식으로 자유롭게 프로젝트를 진행 가능합니다.',
    icon: '✨'
  },
];

export const PLATFORMS = [
  { key: 'instagram', label: '인스타그램' },
  { key: 'youtube',   label: '유튜브' },
  { key: 'blog',      label: '블로그' },
  { key: 'tiktok',    label: '틱톡' },
];

export const MAX_GALLERY = 5;
export const MAX_TOTAL_BYTES = 100 * 1024 * 1024;

export const humanSize = (n) => {
  if (!Number.isFinite(n)) return '-';
  const mb = n / (1024*1024);
  return `${mb.toFixed(1)} MB`;
};
export const sumBytes = (files) => (files || []).reduce((s,f)=>s+(f?.size||0),0);